import React, { useState, useEffect } from "react";
import { C } from "../constants";

export const CompatBadge = ({ score: rawScore }) => {
  const score = rawScore > 0 && rawScore <= 1 ? Math.round(rawScore * 100) : Math.round(rawScore || 0);
  const color = score >= 93 ? C.accent : score >= 85 ? C.teal : score >= 75 ? C.teal : C.sub;
  const heart = score >= 93 ? "❤️" : score >= 85 ? "💚" : "💚";
  const [showTip, setShowTip] = React.useState(false);
  return (
    <span style={{ display:"inline-flex", alignItems:"center", gap:5, position:"relative" }}>
      <span style={{
        background:`${color}18`, border:`1px solid ${color}50`,
        color, borderRadius:20, padding:"3px 10px",
        fontSize:11, fontFamily:"'Space Mono',monospace", fontWeight:700,
        whiteSpace:"nowrap", display:"inline-flex", alignItems:"center", gap:4,
      }}>
        {heart} {score}% compatible
      </span>
      <span
        onMouseEnter={() => setShowTip(true)}
        onMouseLeave={() => setShowTip(false)}
        onClick={() => setShowTip(v => !v)}
        style={{ fontSize:12, color:C.muted, cursor:"pointer", lineHeight:1, userSelect:"none" }}
      >ⓘ</span>
      {showTip && (
        <span style={{
          position:"absolute", top:"calc(100% + 6px)", left:0, zIndex:999,
          background:"#fff", border:`1px solid ${C.border}`, borderRadius:8,
          padding:"10px 14px", boxShadow:"0 4px 16px rgba(0,0,0,0.10)",
          fontSize:11, fontFamily:"'Space Mono',monospace", color:C.text,
          whiteSpace:"nowrap", lineHeight:2,
        }}>
          <div><span style={{color:C.accent}}>❤️ 93–100%</span> — Exceptional match</div>
          <div><span style={{color:C.teal}}>💚 85–92%</span> — Strong match</div>
          <div><span style={{color:C.teal}}>💚 75–84%</span> — Good match</div>
          <div><span style={{color:C.sub}}>below 75%</span> — Potential match</div>
        </span>
      )}
    </span>
  );
};

export const Tag = ({ label }) => (
  <span style={{ background:"#f3f4f6", border:`1px solid rgba(0,0,0,0.15)`, color:"#4b5563", borderRadius:4, padding:"2px 8px", fontSize:11, fontFamily:"'Space Mono',monospace" }}>
    {label}
  </span>
);

export const Pill = ({ children, active, onClick, color }) => (
  <button onClick={onClick} style={{
    background: active ? (color||C.accent) : "transparent",
    border:`1px solid ${active ? (color||C.accent) : "rgba(0,0,0,0.18)"}`,
    color: active ? "#fff" : "#4b5563",
    borderRadius:8, padding:"6px 16px", fontSize:12,
    fontFamily:"'Space Mono',monospace", cursor:"pointer", transition:"all .15s",
  }}>{children}</button>
);

export const Logo = ({ size = 30 }) => (
  <div style={{
    width:size, height:size, borderRadius: size * 0.28,
    background:`linear-gradient(135deg, ${C.accent}, #c0392b)`,
    display:"flex", alignItems:"center", justifyContent:"center",
    fontSize: size * 0.48, boxShadow:`0 0 ${size}px ${C.accentGlow}`,
    flexShrink: 0,
  }}>💘</div>
);

export function ResumeToast({ toast, onDismiss }) {
  if (!toast) return null;
  const colors = {
    accent: { bg: "#fff0f2", border: "#d63651", text: "#d63651" },
    teal:   { bg: "#f0fdf9", border: "#0d9488", text: "#0d9488" },
    gold:   { bg: "#fffbeb", border: "#0d9488", text: "#0d9488" },
    success:{ bg: "#f0fdf9", border: "#0d9488", text: "#0d9488" },
  };
  const c = colors[toast.type] || colors.success;
  return (
    <div key={toast.id} style={{ position:"fixed", top:0, left:0, right:0, bottom:0, display:"flex", alignItems:"center", justifyContent:"center", zIndex:9999, pointerEvents:"none" }}>
      <div style={{ background:c.bg, border:`2px solid ${c.border}`, borderRadius:18, padding:"22px 32px", minWidth:320, maxWidth:440, display:"flex", alignItems:"center", gap:16, boxShadow:"0 20px 60px rgba(0,0,0,0.18)", pointerEvents:"all" }}>
        <div style={{ width:12, height:12, borderRadius:"50%", background:c.border, flexShrink:0 }}/>
        <div style={{ flex:1 }}>
          <div style={{ fontSize:15, fontWeight:800, color:c.text, marginBottom:3 }}>{toast.message}</div>
          {toast.type !== "info" && <div style={{ fontSize:12, color:"#6b7280", fontFamily:"'Space Mono',monospace" }}>Resume updated successfully</div>}
        </div>
        <button onClick={onDismiss} style={{ background:"none", border:"none", cursor:"pointer", color:"#6b7280", fontSize:20, padding:"0 2px", flexShrink:0, lineHeight:1, pointerEvents:"all" }}>×</button>
      </div>
    </div>
  );
}

export function LeadCaptureBar({ show, submitted, email, onEmailChange, onSubmit, loading, onDismiss }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  if (!show) return null;
  return (
    <div style={{ position:"fixed", bottom:0, left:0, right:0, zIndex:250, background:"#1a1a2e", borderTop:"1px solid rgba(255,255,255,0.08)", padding: isMobile ? "12px 16px" : "14px 24px", display:"flex", flexDirection: isMobile ? "column" : "row", alignItems: isMobile ? "stretch" : "center", justifyContent:"center", gap: isMobile ? 8 : 16, animation:"slideUp .35s ease both" }}>
      {submitted ? (
        <div style={{ fontSize:14, fontWeight:600, color:"#fff", display:"flex", alignItems:"center", gap:8, justifyContent:"center" }}>
          <span style={{ color:"#0d9488" }}>&#10003;</span> You&apos;re on the list &mdash; we&apos;ll send your matches shortly.
        </div>
      ) : (
        <>
          <button onClick={onDismiss} style={{ background:"transparent", border:"none", color:"rgba(255,255,255,0.3)", fontSize:18, cursor:"pointer", lineHeight:1, padding:"0 4px", position:"absolute", top:10, right:16 }}>×</button>
          <div style={{ display:"flex", flexDirection:"column", alignItems: isMobile ? "center" : "flex-start" }}>
            <span style={{ fontSize: isMobile ? 13 : 14, fontWeight:700, color:"#fff", fontFamily:"'DM Sans',sans-serif" }}>Get 3 free job matches sent to your inbox</span>
            <span style={{ fontSize:11, color:"rgba(255,255,255,0.45)", fontFamily:"'Space Mono',monospace" }}>No account required &middot; Takes 10 seconds</span>
          </div>
          <div style={{ display:"flex", gap:8, alignItems:"center", paddingRight: isMobile ? 64 : 0 }}>
            <input
              value={email} onChange={e => onEmailChange(e.target.value)}
              onKeyDown={e => e.key === "Enter" && onSubmit()}
              placeholder="your@email.com" type="email"
              style={{ background:"rgba(255,255,255,0.08)", border:"1px solid rgba(255,255,255,0.15)", borderRadius:9, padding:"9px 14px", fontSize:13, color:"#fff", outline:"none", fontFamily:"'DM Sans',sans-serif", flex:1, minWidth:0 }}
            />
            <button onClick={onSubmit} disabled={loading}
              style={{ background:`linear-gradient(135deg,#d63651,#c0392b)`, color:"#fff", border:"none", borderRadius:9, padding:"9px 18px", fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"'DM Sans',sans-serif", whiteSpace:"nowrap", opacity: loading ? 0.7 : 1, flexShrink:0 }}>
              {loading ? "Sending…" : "Send my matches →"}
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ border:`1px solid ${C.border}`, borderRadius:12, overflow:"hidden", background:"#fff", transition:"all .15s" }}>
      <button onClick={() => setOpen(!open)}
        style={{ width:"100%", background:"none", border:"none", padding:"16px 20px", display:"flex", alignItems:"center", justifyContent:"space-between", cursor:"pointer", gap:16 }}>
        <span style={{ fontWeight:600, fontSize:15, color:C.text, textAlign:"left", lineHeight:1.4 }}>{q}</span>
        <span style={{ fontSize:18, color:C.muted, flexShrink:0, transform: open ? "rotate(45deg)" : "none", transition:"transform .2s", fontWeight:300 }}>+</span>
      </button>
      {open && (
        <div style={{ padding:"0 20px 16px", color:C.sub, fontSize:14, lineHeight:1.7, borderTop:`1px solid ${C.border}` }}>
          <div style={{ paddingTop:14 }}>{a}</div>
        </div>
      )}
    </div>
  );
}
